var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"p-4"},[_c('Table',{attrs:{"lang":_vm.lang,"columnNames":['en','ru','az'],"keys":['en','ru','az'],"requests":_vm.requests},on:{"getData":function($event){return _vm.getData(_vm.lang)}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }